import { useRef, useState } from "react";

// Cinematic autoplay-muted video with graceful poster fallback.
// If video URL is missing or fails to load, we keep the poster image visible.
export default function VideoHero({ videoUrl, poster, alt }) {
  const [failed, setFailed] = useState(false);
  const ref = useRef(null);

  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden">
      <img src={poster} alt={alt} className="absolute inset-0 w-full h-full object-cover" />
      {videoUrl && !failed && (
        <video
          ref={ref}
          data-testid="destination-video"
          src={videoUrl}
          poster={poster}
          autoPlay
          muted
          loop
          playsInline
          onError={() => setFailed(true)}
          className="absolute inset-0 w-full h-full object-cover"
          preload="metadata"
        />
      )}
    </div>
  );
}
